import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OrderQuote } from "services/order/types";
import { deleteQuotes, loadQuotes, addQuote, editQuote } from "./actions";

/**
 * Initial state.
 */
const initialState: OrderQuote[] = [];

/**
 * OrderQuote entity adapter slice.
 */
const quotesSlice = createSlice({
  name: "quotes",
  initialState: initialState,
  reducers: {
    resetQuotes(state) {
      state = initialState;

      return state;
    },
    deleteQuotesByIds(state, action: PayloadAction<number[]>) {
      state = state.filter(value => value.id && !action.payload.includes(value.id));

      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadQuotes.fulfilled, (state, action) => {
      if (action.payload.isSuccessful) {
        return action.payload.data ?? [];
      }

      return [];
    });

    builder.addCase(deleteQuotes.fulfilled, (state, action) => {
      if (action.payload.isSuccessful && action.payload.data) {
        action.payload.data?.forEach((id) => {
          const index = state.findIndex(value => value.id === id);
          if (index >= 0) {
            state.splice(index, 1);
          }
        });

        return state;
      }
    });

    builder.addCase(addQuote.fulfilled, (state, action) => {
      if (action.payload.isSuccessful && action.payload.data) {
        state.push(action.payload.data);

        return state;
      }
    });

    builder.addCase(editQuote.fulfilled, (state, action) => {
      if (action.payload.isSuccessful && action.payload.data) {
        const index: number = state.findIndex(value => value.id === action.payload.data?.id);
        if (index >= 0) {
          state.splice(index, 1, action.payload.data);
        }

        return state;
      }
    });
  },
});

export const { resetQuotes, deleteQuotesByIds } = quotesSlice.actions;

export default quotesSlice.reducer;
